module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-15-0595f2a3f809fddfd318d8d2851ada51.jpg";